import React, { useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import ModalClose from '../components/order/ModalClose'
import { ACCESS_SERVICES_MAP, ORDER_METHOD } from '../constants'
import { getRestaurantServices } from '../selectors'

const ModalCloseContainer = () => {
    const services = useSelector(getRestaurantServices)
    const hasMultiServicesForWeb = [
        ACCESS_SERVICES_MAP[ORDER_METHOD.PICKUP],
        ACCESS_SERVICES_MAP[ORDER_METHOD.DELIVERY],
    ].some(s => services.includes(s))
    const [showOvertime, setShowOvertime] = useState()
    

    useEffect(() => {
        if(!hasMultiServicesForWeb) setShowOvertime(true);
    }, [hasMultiServicesForWeb])

    return (
        <ModalClose
            isOpen={showOvertime}
        />
    )
}

export default ModalCloseContainer
